/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Badge,
  BlockStack,
  Button,
  Checkbox,
  FormLayout,
  Icon,
  Modal,
  Text,
  TextField,
} from "@shopify/polaris";
import { HideIcon, ViewIcon } from "@shopify/polaris-icons";
import { Controller, useForm } from "react-hook-form";
import { useChangePasswordByAdminMutation } from "../../store/store/slices/UsersRTK";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { showToast } from "../../store/store/slices/AlertSlice";

const ChangePassword = ({ user_id }: { user_id: string }) => {
  const {
    reset,
    control,
    getValues,
    watch,
    formState: { errors },
  } = useForm();
  const dispatch = useDispatch();
  const [changePassword, { isLoading, isError, isSuccess, error }] =
    useChangePasswordByAdminMutation<any>();
  const [passwordConfirmationModal, setPasswordConfirmationModal] =
    useState(false);
  const [logoutAllDevices, setLogoutAllDevices] = useState<boolean>(false);
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const onCheckBoxChange = (checkStatus: boolean) => {
    setLogoutAllDevices(() => checkStatus);
  };
  const BUTTON_DISABLED = isLoading || !user_id || !watch("password");
  const onChangePasswordHandler = async () => {
    const values = getValues();
    await changePassword({
      id: user_id,
      ...values,
      logoutFromAllDevices: logoutAllDevices,
    });
  };
  const onShowPasswordHandler = async () => {
    setShowPassword((prev) => !prev);
  };

  useEffect(() => {
    if (isSuccess) {
      dispatch(
        showToast({
          message: "Password has been changed",
          error: false,
          visible: true,
        })
      );
      reset({ password: "" });
    }
    if (isError) {
      dispatch(
        showToast({
          message: error?.data?.errors[0]?.msg,
          error: true,
          visible: true,
        })
      );
    }
  }, [isLoading, isError, isSuccess, error]);
  return (
    <>
      <BlockStack gap={"200"}>
        <FormLayout.Group>
          <Controller
            name="password"
            control={control}
            render={({ field }) => (
              <div style={{ position: "relative" }}>
                <span
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "20px",
                    padding: "0",
                    position: "absolute",
                    right: "5px",
                    top: "30px",
                    zIndex: "100000",
                    cursor: "pointer",
                  }}
                  onClick={onShowPasswordHandler}
                >
                  <Icon source={!showPassword ? ViewIcon : HideIcon} />
                </span>
                <TextField
                  {...field}
                  autoComplete="off"
                  label="Password"
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter password here..."
                  requiredIndicator
                  error={errors.password && "Password is required"}
                ></TextField>{" "}
              </div>
            )}
          />
        </FormLayout.Group>
        <div style={{ display: "flex", justifyContent: "end" }}>
          <Button
            size="micro"
            onClick={() => {
              setPasswordConfirmationModal(true);
            }}
            loading={isLoading}
            disabled={isLoading || BUTTON_DISABLED}
          >
            Change password
          </Button>
        </div>
      </BlockStack>
      <Modal
        onClose={() => setPasswordConfirmationModal(false)}
        open={passwordConfirmationModal}
        title="Password change confirmation"
        primaryAction={{
          content: "Change password",
          onAction: async () => {
            setPasswordConfirmationModal(false);
            await onChangePasswordHandler();
          },
        }}
        secondaryActions={[
          {
            content: "Cancel",
            onAction: () => {
              setPasswordConfirmationModal(false);
            },
          },
        ]}
      >
        <Modal.Section>
          <BlockStack gap={"300"}>
            <p>Are you sure you want to change the password?</p>
            <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
              <div>
                <Checkbox
                  checked={logoutAllDevices}
                  onChange={onCheckBoxChange}
                  label={
                    <Badge tone="attention">Logout from all devices?</Badge>
                  }
                ></Checkbox>
              </div>
            </div>
          </BlockStack>
        </Modal.Section>
      </Modal>
    </>
  );
};

export default ChangePassword;
